export default {
    parts: [],
    baseStyle: (props) => ({
        container: {
            position: 'relative',
            ...(props?.BannerViewMode === 'Background Image' && {
                overflow: 'hidden'
            }),
            textTransform: 'inherit',
            ...(props?.BannerViewMode === 'Background Color' && {
                backgroundColor: props?.BackgroundColor || props?.BackgroundColorPicker || 'white'
            }),
            ...(props?.BannerViewMode !== 'Background Color' && {
                backgroundColor: {
                    base: props?.BackgroundColor || props?.BackgroundColorPicker || 'white',
                    lg: 'white'
                }
            }),
            ...(props?.ResponsiveBackgroundMedia &&
                props?.BannerViewMode === 'Split Image And Color' && {
                    display: 'flex',
                    flexDirection: {base: 'column', lg: 'row'}
                }),
            width: '100%'
        },
        wrapper: {
            position: 'relative',
            display: 'flex',
            flexDirection: {
                base: 'column',
                lg:
                    props?.BannerViewMode === 'Background Color' &&
                    props?.CtaAlignment === 'horizontal'
                        ? 'row'
                        : props?.CtaAlignment === 'horizontal'
                        ? 'row'
                        : 'column'
            },
            alignItems: 'center',
            ...(props?.CtaAlignment === 'horizontal' && {
                gap: {lg: '31px'}
            }),

            ...(props?.BannerViewMode === 'Background Color' &&
                props?.CtaAlignment === 'horizontal' && {
                    gap: {base: '16px', lg: '24px'},
                    alignItems: {base: 'center', lg: 'center'}
                }),

            /* Mobile alignment for horizontal CTA - apply BannerAlignment on mobile */
            ...(props?.BannerViewMode === 'Background Color' &&
                props?.CtaAlignment === 'horizontal' &&
                props?.BannerAlignment === 'left' && {
                    alignItems: {base: 'start', lg: 'center'},
                    textAlign: {base: 'left', lg: 'center'}
                }),

            ...(props?.BannerViewMode === 'Background Color' &&
                props?.CtaAlignment === 'vertical' && {
                    gap: {base: '16px'},
                    alignItems: 'center'
                }),

            ...(props?.ResponsiveBackgroundMedia &&
                props?.BannerViewMode === 'Split Image And Color' && {
                    flex: {base: 'none', lg: '0 0 50%'},
                    order: {base: 1, lg: 0},
                    width: {base: '100%', lg: 'auto'}
                }),

            ...(props?.BannerViewMode === 'Background Image' && {
                flex: 1
            }),

            ...(props?.BannerViewMode === 'Background Color' && {
                width: '100%'
            }),

            backgroundColor: props?.BackgroundColor || props?.BackgroundColorPicker || 'white',

            /* Banner Alignments */
            /* Left */
            ...(props?.CtaAlignment === 'vertical' &&
                props?.BannerAlignment === 'left' && {
                    alignItems: 'start',
                    justifyContent: 'end',
                    textAlign: 'left'
                }),

            /* Left / Center*/
            ...(props?.CtaAlignment === 'vertical' &&
                props?.BannerAlignment === 'left/center' && {
                    alignItems: 'start',
                    justifyContent: 'center',
                    textAlign: 'left'
                }),

            /* Left / Top*/
            ...(props?.CtaAlignment === 'vertical' &&
                props?.BannerAlignment === 'left/top' && {
                    alignItems: 'start',
                    justifyContent: 'start',
                    textAlign: 'left'
                }),

            /* Center / Top*/
            ...(props?.CtaAlignment === 'vertical' &&
                props?.BannerAlignment === 'center/top' && {
                    alignItems: 'center',
                    justifyContent: 'start',
                    textAlign: 'left'
                }),

            /* Center / Center */
            ...(props?.CtaAlignment === 'vertical' &&
                props?.BannerAlignment === 'center' && {
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center'
                }),

            /* Top / Right */
            ...(props?.CtaAlignment === 'vertical' &&
                props?.BannerAlignment === 'top/right' && {
                    alignItems: 'end',
                    justifyContent: 'start',
                    textAlign: 'right'
                }),

            /* Center Right */
            ...(props?.CtaAlignment === 'vertical' &&
                props?.BannerAlignment === 'center/right' && {
                    alignItems: 'end',
                    justifyContent: 'center',
                    textAlign: 'right'
                }),

            /* Right */
            ...(props?.CtaAlignment === 'vertical' &&
                props?.BannerAlignment === 'right' && {
                    alignItems: 'end',
                    justifyContent: 'end',
                    textAlign: 'right'
                }),

            /* Banner Size */
            ...(props?.BannerSize === 'x-small' && {
                minHeight: {base: '50px', lg: '100px'},
                gap: {base: '4px', lg: '4px'}
            }),

            ...(props?.BannerSize === 'small' && {
                minHeight: {base: '144px', lg: '200px'},
                gap: {base: '8px', lg: '8px'}
            }),

            ...(props?.BannerSize === 'medium' && {
                minHeight: {base: '200px', lg: '300px'},
                gap: {base: '8px', lg: '8px'}
            }),

            padding: {base: '24px 0', lg: '20px 24px'}
        },
        contentWrapper: {
            zIndex: '2',
            ...(props?.CtaAlignment === 'horizontal' && {
                flex: {lg: 1}
            })
        },
        imageWrapper: {
            display: {base: 'none', lg: 'block'},
            ...(props?.BannerViewMode === 'Background Image' && {
                display: {base: 'block'},
                position: 'absolute',
                left: '0',
                top: '0',
                zIndex: '1',
                width: '100%',
                height: '100%',
                '& div': {
                    height: '100%',
                    width: '100%'
                },
                '& img': {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center center'
                }
            }),
            ...(props?.BannerViewMode === 'Background Color' && {
                display: 'block',
                flexShrink: 0,
                maxWidth: '200px',
                height: 'auto',
                '& img': {
                    maxWidth: '100%',
                    height: 'auto',
                    display: 'block'
                }
            }),
            ...(props?.BannerViewMode === 'Split Image And Color' && {
                display: 'flex',
                flex: {base: 'none', lg: '0 0 50%'},
                order: {base: 2, lg: 0},
                // Negative margin to make image bleed on mobile (counteract notFullBleed padding)
                marginLeft: {base: -4, lg: 0},
                marginRight: {base: -4, lg: 0},
                // Compensate width for negative margins on mobile
                width: {base: 'calc(100% + 32px)', lg: 'auto'},
                '& div': {
                    height: '100%',
                    width: '100%'
                },
                '& img': {
                    width: '100%',
                    height: {base: 'auto', lg: '100%'},
                    objectFit: 'cover',
                    objectPosition: 'right center'
                }
            })
        },
        ctaWrapper: {
            display: 'flex',
            flexWrap: 'no-wrap',
            alignItems: 'center',
            zIndex: '2',
            gap: 2,

            ...(props?.CtaAlignment === 'horizontal' && {
                width: {base: '100%', lg: 'unset'}
            }),

            // Only apply marginTop for Background Image mode
            ...(props?.BannerViewMode === 'Background Image' && {
                marginTop: {base: 3, lg: 5}
            })
        },
        preTitle: {
            fontSize: {base: 'xs'},
            lineHeight: {base: '100%'},
            marginY: {base: 1}
        },
        title: {
            fontSize: {base: 'md', lg: 'xl'},
            fontWeight: 'bold',
            lineHeight: {base: '100%'},
            marginY: {base: 3, lg: 2}
        },
        description: {
            fontSize: {base: 'sm'},
            lineHeight: {base: '18px'},
            marginY: {base: 3, lg: 1}
        },
        disclaimer: {
            fontSize: {base: 'xs'},
            lineHeight: {base: '15px'}
        },
        dividerStyling: {
            borderColor: {base: props?.TextColor || 'black'},
            borderWidth: {base: '1px'},
            marginLeft: {base: 3},
            marginRight: {base: 3},
            height: 'fill-available'
        }
    })
}
